import {Component, Input, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component( {
	selector: 'indiapicture-video-modal',
	templateUrl: './video-modal.component.html',
	styleUrls: [ './video-modal.component.scss' ]
} )

export class VideoModalComponent implements OnInit {

	@Input() url = 'https////www.youtube.com/embed/vBPgmASQlll1A0?autoplay=1';

	constructor ( private modalService: NgbActiveModal ) {
	}

	ngOnInit (): void {
	}

	closeModal () {
		this.modalService.dismiss();
	}
}
